import { Badge } from "@/design-system/components/ui";
import type { ReportGenerationStage } from "@/api/reportsV32";

// LLM & Reports v3.2 §8.2 — three-stage lifecycle indicator. Maps each
// GenerationStage onto the existing design-system Badge variants so the
// reports list, detail page, and any future surface get consistent
// colours without inventing new tokens.
//
//   Drafted          → status="draft"     (gray-mid)
//   BrandingApplied  → status="gold"      (gold.DEFAULT)
//   Finalized        → status="finalized" (status.success green)
//
// Treats null / undefined / unknown as the legacy "draft" so v3.1 rows
// that haven't been backfilled don't render a blank cell.

const STAGE_CONFIG: Record<
  ReportGenerationStage,
  { variant: "draft" | "gold" | "finalized"; label: string }
> = {
  Drafted: { variant: "draft", label: "Draft" },
  BrandingApplied: { variant: "gold", label: "Branding applied" },
  Finalized: { variant: "finalized", label: "Finalized" },
};

export interface StageBadgeProps {
  stage: ReportGenerationStage | null | undefined;
  className?: string;
}

export function StageBadge({ stage, className }: StageBadgeProps) {
  const cfg = (stage && STAGE_CONFIG[stage]) ?? STAGE_CONFIG.Drafted;
  return (
    <Badge status={cfg.variant} className={className} aria-label={`Stage: ${cfg.label}`}>
      {cfg.label}
    </Badge>
  );
}
